import React from 'react';
import { Booking } from '../types/booking.types';

interface AddressCardProps {
  booking: Booking;
}

const AddressCard: React.FC<AddressCardProps> = ({ booking }) => {
  return (
    <div className="bg-green-50 rounded-lg p-4 border border-green-100">
      <h3 className="text-sm font-semibold text-green-800 mb-3 flex items-center">
        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        Service Address
      </h3>
      <div className="space-y-2 text-sm">
        {booking.address_details ? (
          <>
            <p className="text-gray-700">
              <span className="font-medium">House:</span> {booking.address_details.house}
            </p>
            <p className="text-gray-700">
              <span className="font-medium">Address:</span> {booking.address_details.address}
            </p>
            <p className="text-gray-700">
              <span className="font-medium">Landmark:</span> {booking.address_details.landmark}
            </p>
            <p className="text-gray-700">
              <span className="font-medium">Label:</span>{' '}
              <span className="px-2 py-0.5 bg-green-200 rounded text-xs">
                {booking.address_details.address_label}
              </span>
            </p>
          </>
        ) : (
          <p className="text-gray-700">{booking.customer_address}</p>
        )}
      </div>
    </div>
  );
};

export default AddressCard;
